export interface PWAEvent {
  id: number;
  title: string;
  subtitle: string;
  date: string;
  time: string;
  venue: string;
  address: string;
  city: string;
  image: string;
  status: "upcoming" | "past";
  highlights: string[];
  description: string;
  ticketUrl: string;
}

export const events: PWAEvent[] = [
  {
    id: 1,
    title: "PWA: Championship Showdown",
    subtitle: "The Night of Reckoning",
    date: "April 12, 2026",
    time: "7:00 PM PT",
    venue: "Metroflex Sports Complex",
    address: "12551 E Carson St",
    city: "Hawaiian Gardens, CA 90716",
    image: "https://framerusercontent.com/images/dNTDjruMF3TCYJ4LZTtrsb3WtQ.png",
    status: "upcoming",
    highlights: ["PWA Heavyweight Title Match", "El Chivo vs. The Wretched One", "Lucha Showcase", "Special Appearances"],
    description: "The biggest night in PWA history is almost here. Championship Showdown promises a full card of elite matchups, title defenses, and a main event that will be talked about for years. The Wretched One has demanded his shot at championship gold — and The Showstopper Eli Emerson is ready to answer. Don't miss this one.",
    ticketUrl: "/events",
  },
  {
    id: 2,
    title: "PWA: Summer Slam Spectacular",
    subtitle: "High Stakes Summer Night",
    date: "June 7, 2026",
    time: "7:00 PM PT",
    venue: "Metroflex Sports Complex",
    address: "12551 E Carson St",
    city: "Hawaiian Gardens, CA 90716",
    image: "https://framerusercontent.com/images/WqNOWTjbmIVtjiaEDYeI45Ieo.png",
    status: "upcoming",
    highlights: ["Tag Team Titles on the Line", "Candy Girl Title Defense", "Battle Royal", "Fan Meet & Greet"],
    description: "Summer kicks into high gear with PWA's most stacked summer card yet. Multiple title matches, a fan-favorite battle royal, and a special fan meet and greet session before the show. Bring the whole family for an unforgettable evening of live professional wrestling action.",
    ticketUrl: "/events",
  },
  {
    id: 3,
    title: "PWA: Summer Star Wars – Fight Night",
    subtitle: "Summertime Chaos",
    date: "July 13, 2025",
    time: "7:00 PM PT",
    venue: "Metroflex Sports Complex",
    address: "12551 E Carson St",
    city: "Hawaiian Gardens, CA 90716",
    image: "https://framerusercontent.com/images/WqNOWTjbmIVtjiaEDYeI45Ieo.png",
    status: "past",
    highlights: ["Main Event: Eli Emerson vs. The Wretched One", "Lucha Showcase: El Chivo", "Women's Feature: Candy Girl", "Tag Team Chaos"],
    description: "Summer Star Wars: Fight Night exploded into Hawaiian Gardens on Sunday night, July 13, 2025! PWA packed the Metroflex Gym with a stacked card, big-time entrances, and summertime crowd heat you could only feel live. Fast-paced clashes, Lucha flair, and hard-hitting grudge matches under the bright lights.",
    ticketUrl: "#",
  },
  {
    id: 4,
    title: "PWA World Cup",
    subtitle: "International Glory",
    date: "February 10, 2025",
    time: "7:00 PM PT",
    venue: "Metroflex Sports Complex",
    address: "12551 E Carson St",
    city: "Hawaiian Gardens, CA 90716",
    image: "https://framerusercontent.com/images/jMmDZ26wqsxYyRAHXrefJ7z43o.png",
    status: "past",
    highlights: ["World Cup Tournament Bracket", "International Competitors", "El Chivo International Showcase", "Special Appearances"],
    description: "PWA World Cup brought international-sized energy to Hawaiian Gardens. A night packed with rivalries, surprise showdowns, and the electric atmosphere only PWA delivers. Big entrances, high-impact clashes, and non-stop crowd heat as contenders fought for bragging rights under the World Cup banner.",
    ticketUrl: "#",
  },
  {
    id: 5,
    title: "PWA Heavyweight Championship Tournament",
    subtitle: "Crowning the First Champion",
    date: "July 13, 2024",
    time: "7:00 PM PT",
    venue: "Metroflex Sports Complex",
    address: "12551 E Carson St",
    city: "Hawaiian Gardens, CA 90716",
    image: "https://framerusercontent.com/images/jJsap1mEztdkqsIDongd5h6zJjM.png",
    status: "past",
    highlights: ["Super Eight Tournament Bracket", "First PWA Heavyweight Champion Crowned", "Tag Team Showcase", "Historic Night"],
    description: "The road to the first-ever PWA World Heavyweight Champion ran through Hawaiian Gardens. A stacked Super Eight Heavyweight Championship Tournament at the Metroflex Sports Complex — hard-hitting singles bouts, a special tag team showcase, and the kind of live energy you can only feel ringside. History was made.",
    ticketUrl: "#",
  },
];
